import { useLingui } from '@lingui/react/macro'
import { Text } from 'designSystem/components/Text'
import React, { memo } from 'react'

import { ClearButton, CloseIcon, FieldGroup, TextInput } from './styles'
import type { FilterFieldConfig } from './types'

const TextFilterFieldBase: React.FC<{
  field: FilterFieldConfig
  value: string
  onChange: (value: string) => void
  onFilterCommit?: () => void
}> = ({ field, value, onChange, onFilterCommit }) => {
  const { t, i18n } = useLingui()
  const hasValue = value.length > 0

  return (
    <FieldGroup>
      <Text
        as='span'
        size='xxs'
        weight='semibold'
        color='muted'
        leading='tight'>
        {i18n._(field.label)}
      </Text>
      <div style={{ position: 'relative', display: 'flex' }}>
        <TextInput
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => onFilterCommit?.()}
          placeholder={t`Filter...`}
        />
        {hasValue && (
          <ClearButton
            style={{
              position: 'absolute',
              right: '0.375rem',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
            onClick={() => {
              onChange('')
              onFilterCommit?.()
            }}>
            <CloseIcon />
          </ClearButton>
        )}
      </div>
    </FieldGroup>
  )
}

export const TextFilterField = memo(TextFilterFieldBase)
